import { defineMessages } from "react-intl"

export const messages = defineMessages({
	exteriorColor: {
		defaultMessage: "Exterior Color",
		id: "inventorylist.addVehicle.searchResult.exteriorColor",
	},
	interiorColor: {
		defaultMessage: "Interior Color",
		id: "inventorylist.addVehicle.searchResult.interiorColor",
	},
	location: {
		defaultMessage: "Location",
		id: "inventorylist.addVehicle.searchResult.location",
	},
	modelGeneration: {
		defaultMessage: "Model generation",
		id: "inventorylist.addVehicle.searchResult.modelGeneration",
	},
	modelYearLabel: {
		defaultMessage: "Model Year",
		id: "vehicle.modelInformation.modelYear",
	},
	noVehicleFoundHeadline: {
		defaultMessage: "No vehicle found",
		id: "inventorylist.addVehicle.searchResult.noVehicleFound.headline",
	},
	noVehicleFoundMessage: {
		defaultMessage: "Please check your entry or add vehicle manually.",
		id: "inventorylist.addVehicle.searchResult.noVehicleFound.message",
	},
	roofColor: {
		defaultMessage: "Rooftop Color",
		id: "inventorylist.addVehicle.searchResult.rooftopColor",
	},
})
